import { Navigate } from 'react-router'

import { withNamespaces } from '@/i18n/route-namespaces'

export const conversationHistoryRoutes = {
  path: 'conversation-history',
  lazy: withNamespaces(['conversationHistory'], async () => {
    const { ConversationHistory } = await import('@/pages/conversation-history')

    return { Component: ConversationHistory }
  }),
  children: [
    {
      index: true,
      element: <Navigate to="list" />,
    },
    {
      path: 'list',
      lazy: withNamespaces(['conversationHistory'], async () => {
        const { ConversationHistoryList } = await import(
          '@/pages/conversation-history/list'
        )

        return { Component: ConversationHistoryList }
      }),
    },
  ],
}
